export const ADMIN_AUDIT_LOGS_PATH = '/admin/audit-logs';

/**
 * Only GALLERY_ADMINS have access to this page. It is currently hardcoded
 */
export const ADMIN_FULLY_CONNECTED_PATH = `/admin/fully-connected`;

export const ADMIN_GLUE_PATH = '/admin/glue';
export const ADMIN_HOME_PATH = '/admin/home';

export const ADMIN_ORGANIZATION_PATHS = [
  '/admin/organization',
  '/admin/organizations',
];
export const ADMIN_RAMP_PATH = '/admin/ramp';
export const ADMIN_USERS_PATH = '/admin/users';
